<div class="container-fluid">
  <h3>Apply</h3>
  <app-asset-shared-branch-list
    [(branchDistributionList)]="applyBranches"
    [allowAdding]="true"
  ></app-asset-shared-branch-list>

  <hr />

  <h3>Return</h3>

  <app-asset-shared-branch-list
    [(branchDistributionList)]="returnBranches"
    [allowAdding]="true"
  ></app-asset-shared-branch-list>

  <hr />
  <div class="row mb-2">
    <div class="col">
      <div class="form-floating">
        <textarea 
          type="text"
          class="form-control"
          id="reason"
          name="reason"
          placeholder="Reason/Remark"
          [(ngModel)]="remark"
          required
        ></textarea>
        <label for="reason">Reason/Remark</label>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button
      class="btn btn-success"
      (click)="submit()"
      [disabled]="disableSubmit"
    >
      Submit
    </button>
  </div>
</div>
